import React from 'react'
import { Project } from 'src/core/models'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { ProjectDetailsCollapse } from '../index'
import ProjectDetailsInfo from './ProjectDetailsInfo/ProjectDetailsInfo'
import ProjectDetailsGoogleMapLocation from './ProjectDetailsGoogleMapLocation/ProjectDetailsGoogleMapLocation'

interface PropsType {
  project: Project,
  isModalPreview: boolean
}

const ProjectDetailsInfoContent: React.FC<PropsType> = ({ project, isModalPreview }) => {
  const { t } = useTranslation()

  return (
    <ProjectDetailsCollapse label={<CustomText label={t('Projects.Info')} strong/>}>
      {project.latitude && project.longitude && (
        <ProjectDetailsGoogleMapLocation
          latitude={project.latitude}
          longitude={project.longitude}
        />
      )}
      <ProjectDetailsInfo project={project} isModalPreview={isModalPreview} />
    </ProjectDetailsCollapse>
  )
}

export default ProjectDetailsInfoContent
